import React from 'react';
import { Typography, RegularButton } from 'fronton-react';
import { cx } from 'linaria';
import { useTranslation } from 'react-i18next';
import { patchUrlByLocale } from 'utils';
import {
  suggestionContentWrap,
  suggestionTextContentWrap,
  suggestionButton,
  suggestion as suggestionStyle,
  suggestionText,
} from './suggestion-list-item-styles';
import { SuggestionsGaMetaInfo } from '../../types';
import { ArrowUpRightIcon } from '@fronton/icons-react';
import { SuggestionListItemNewImage } from './suggestion-list-item-new-image';
import { PinnedSuggestion } from 'types/model';

export interface SuggestionListItemPromoPageProps {
  elementIndex: number;
  navigationIndex: number;
  isSrp: boolean;
  suggestionSelector: string;
  buttonAction: (
    id: number,
    linkToNavigate?: string,
    gaMeta?: SuggestionsGaMetaInfo,
  ) => React.HTMLAttributes<HTMLButtonElement>;
  suggestion: PinnedSuggestion;
}

export const SuggestionListItemPromoPage = (props: SuggestionListItemPromoPageProps) => {
  const { isSrp, navigationIndex, elementIndex, buttonAction, suggestion } = props;
  const { title, description, url, imageUrl } = suggestion;

  const { t } = useTranslation();

  return (
    <div role="option" aria-selected={elementIndex === navigationIndex} data-qa-header-search-suggestion="">
      <RegularButton
        variant="pseudo"
        tabIndex={-1}
        className={cx(
          suggestionStyle,
          elementIndex === navigationIndex && 'active',
          isSrp && suggestionButton,
        )}
        data-qa="suggestion-button"
        {...buttonAction(elementIndex, url, {
          block: t('header.promo.promo-block'),
          index: elementIndex,
          text: title,
        })}
        href={patchUrlByLocale({ url })}
      >
        <div className={suggestionContentWrap}>
          <SuggestionListItemNewImage
            src={imageUrl}
            alt={title}
            fallback={<ArrowUpRightIcon type="outline" size="l" color="text-minor" />}
          />
          <div className={suggestionTextContentWrap}>
            <Typography variant="m" size="body_short" className={suggestionText} color="text-primary">
              {title}
            </Typography>
            <Typography variant="caption" color="text-secondary">
              {description}
            </Typography>
          </div>
        </div>
      </RegularButton>
    </div>
  );
};
